export =[
    {
        "color": [
            0,
            0,
            0,
            255
        ],
        "type": "esriTS",
        "horizontalAlignment": "center",
        "angle": 0,
        "xoffset": 0,
        "yoffset": 0,
        "text": "Sample Text",
        "rotated": false,
        "kerning": true,
        "font": {
            "size": 10,
            "style": "normal",
            "variant": "normal",
            "weight": "normal",
            "family": "serif"
        }
    }
];